// import { dayjs } from "./dayjs"

export * from "./dayjs"
export * from "./download"
export * from "./env"
export * from "./firebase"
export * from "./format"
export * from "./price-utils"
export * from "./storage"
export * from "./styles"
export * from "./trpc"
export * from "./uniwind"
export * from "./orders"
export * from "./version-compare"

/**
 * @deprecated use priceFromDBFormat instead
 */
// Re-export specific utils
import { priceFromDBFormat } from "./price-utils"

export function formatPrice(price?: number | null) {
  if (price === undefined || price === null) {
    return undefined
  }
  // Convert from milli-units and format
  return priceFromDBFormat(price).toFixed(2).replace(".00", "")
}

export function getScaleCode(upc: string) {
  return upc.slice(0, 7).replace(/^20+/g, "")
}
